import { DTOObjectMetadata } from "../aux";
import { z } from "zod";
export const DTOForgeProjectContextFeedbackSentiment = z.enum([
    "Positive",
    "Neutral",
    "Negative",
    "Aggressive",
]);
export const DTOForgeProjectContextFeedbackState = z.enum([
    "Resolved",
    "Unresolved",
]);
export const DTOForgeProjectContextFeedbackCategory = z.enum([
    "MissingInformation",
    "Incorrect",
    "Output",
    "WrongSource",
]);
export const DTOForgeProjectContextFeedback = z.object({
    id: z.string().uuid(),
    workspaceId: z.string(),
    contextId: z.string(),
    createdByUserId: z.string().optional(),
    createdAt: z.coerce.date(),
    message: z
        .string()
        .describe("A concise human-readable summary of the feedback being collected."),
    description: z
        .string()
        .optional()
        .describe("Optional additional details that expand on the feedback summary."),
    conversation: z
        .array(z.string())
        .describe("Ordered conversation excerpts that provide context for the feedback. Each item should be one message."),
    sentiment: DTOForgeProjectContextFeedbackSentiment.describe("Overall sentiment of the feedback. Use Positive, Neutral, Negative, or Aggressive."),
    state: DTOForgeProjectContextFeedbackState,
    category: DTOForgeProjectContextFeedbackCategory,
    llm: z
        .object({
        model: z
            .string()
            .describe("The LLM model name that generated or participated in the conversation."),
        provider: z.string().describe("The LLM provider name."),
    })
        .describe("Information about the LLM associated with this feedback."),
    metadata: DTOObjectMetadata.optional(),
});
export const DTOForgeProjectContextFeedbackCreatePayload = DTOForgeProjectContextFeedback.pick({
    contextId: true,
    message: true,
    description: true,
    conversation: true,
    sentiment: true,
    category: true,
    metadata: true,
    llm: true,
});
export const DTOForgeProjectContextFeedbackListQuery = z
    .object({
    contextId: z.string().optional(),
    workspaceId: z.string().optional(),
    designSystemId: z.string().optional(),
})
    .refine((query) => Boolean(query.contextId) ||
    Boolean(query.workspaceId) ||
    Boolean(query.designSystemId), "At least one of contextId, workspaceId, or designSystemId is required.");
export const DTOForgeProjectContextFeedbackDeletePayload = z.object({
    id: z.union([z.string(), z.array(z.string())]),
});
export const DTOForgeProjectContextFeedbackUpdatePayload = z.object({
    id: z.string(),
    state: DTOForgeProjectContextFeedbackState,
});
export const DTOForgeProjectContextFeedbackResponse = z.object({
    feedback: DTOForgeProjectContextFeedback,
});
export const DTOForgeProjectContextFeedbackListResponse = z.object({
    feedback: z.array(DTOForgeProjectContextFeedback),
});
export const DTOForgeProjectContextFeedbackDeleteResponse = z.object({
    ok: z.literal(true),
});
